export default {
  LOCATION_EXPIRED: "LOCATION_EXPIRED"
};
